import { formatDateOnlyLocal } from '@erp/shared-utils';
import { Badge } from '@/components/ui/badge';
import { T } from 'gt-react';

interface PeriodStatusPillProps {
  startDate: string | null;
  endDate: string | null;
}

export function PeriodStatusPill({
  startDate,
  endDate,
}: PeriodStatusPillProps) {
  if (!startDate && !endDate) {
    return <span className="text-muted-foreground">-</span>;
  }

  const todayString = formatDateOnlyLocal(new Date()); // YYYY-MM-DD in the user's local calendar date

  const isUpcoming = startDate !== null && startDate > todayString;
  const isExpired = endDate !== null && endDate < todayString;
  const isActive = !isUpcoming && !isExpired;

  if (isUpcoming) {
    return (
      <Badge
        variant="secondary"
        className="bg-blue-100 text-blue-800 hover:bg-blue-100"
      >
        <T context="badge label indicating a period that has not yet started">
          Upcoming
        </T>
      </Badge>
    );
  }

  return (
    <Badge
      variant={isActive ? 'default' : 'destructive'}
      className={
        isActive
          ? 'bg-green-100 text-green-800 hover:bg-green-100'
          : 'bg-red-100 text-red-800 hover:bg-red-100'
      }
    >
      {isActive ? (
        <T context="badge label for an active period">Active</T>
      ) : (
        <T context="badge label for an expired period">Expired</T>
      )}
    </Badge>
  );
}
